import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import './registerServiceWorker'
import { remJS } from './utils/rem'
import { Swipe, SwipeItem, Lazyload, Toast } from 'vant'
// import 'vant/lib/swipe/style'
import 'vant/lib/index.css'
import clipboard from 'clipboard'
import mobileUI from './utils/mobile'

import VueAwesomeSwiper from 'vue-awesome-swiper'

Vue.config.productionTip = false
// 注册到vue原型上
Vue.prototype.Clipboard = clipboard

Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Toast)
Vue.use(Lazyload, { lazyComponent: true })

mobileUI()
if (isMobile()) {
  // 当前设备是移动设备
  console.log('mobile')
  remJS(document, window)
} else {
  // 当前设备是pc端
  console.log('pc')
}

Vue.use(VueAwesomeSwiper) 

function isMobile() { 
  return ('ontouchstart' in document.documentElement)
}

router.beforeEach((to, from, next) => {
  if(to.name == 'Bless'){
    window.scrollTo(0, 0)
  }
  next();
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
